import { Component, OnInit, NgZone } from '@angular/core';
import { AmbitService } from '../ambit.service';
import * as firebase from 'firebase';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-driver-requests',
  templateUrl: './driver-requests.component.html',
  styleUrls: ['./driver-requests.component.css']
})
export class DriverRequestsComponent implements OnInit {

  public searchList: any = ['userName', 'email'];
  public sortColumn: any = 'status';
  public sortType: boolean = true;

  constructor(public router: Router,
    private toastr: ToastrService,
    public service: AmbitService) {

    if (this.service.adminUser.userAccess.drivers == 'None') {
      this.router.navigate(['/home']);
    }

  }

  ngOnInit() {}

  toggleSortValue(val) {
    if (this.sortColumn == val) { this.sortType = !this.sortType; }
    else { this.sortColumn = val; }
  }

}